import axiosInstance from '../config/axios';

// إضافة الـ token لكل الطلبات
axiosInstance.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
}, (error) => {
    return Promise.reject(error);
});

// خدمات المشرفين
export const fetchAdmins = async (params = {}) => {
    try {
        const response = await axiosInstance.get('/api/admin/users', { 
            params: { 
                ...params,
                role_ids: [1, 2] // عرض المديرين والمشرفين في صفحة المشرفين
            } 
        });
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message || 'حدث خطأ أثناء جلب المشرفين';
    }
};

export const createAdmin = async (adminData) => {
    try {
        // الآن نستخدم البيانات كما هي من النموذج مباشرة
        // لأن المستخدم يختار الدور من القائمة المنسدلة
        const response = await axiosInstance.post('/api/admin/users', adminData);
        return response.data;
    } catch (error) {
        if (error.response?.data?.errors) {
            // تجميع كل رسائل الخطأ في مصفوفة واحدة
            const errorMessages = Object.values(error.response.data.errors).flat();
            throw errorMessages.join('\n');
        }
        throw error.response?.data?.message || error.message || 'حدث خطأ أثناء إضافة المشرف';
    }
};

export const updateAdmin = async (id, adminData) => {
    try {
        const response = await axiosInstance.put(`/api/admin/users/${id}`, adminData);
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

export const deleteAdmin = async (id) => {
    try {
        const response = await axiosInstance.delete(`/api/admin/users/${id}`);
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

export const changeAdminPassword = async (id, passwordData) => {
    try {
        const response = await axiosInstance.post(`/api/admin/users/${id}/change-password`, passwordData);
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

export const changeAdminStatus = async (id, status) => {
    try {
        // تعديل من patch إلى put وإزالة /status من المسار
        const response = await axiosInstance.put(`/api/admin/users/${id}`, { status });
        return response.data;
    } catch (error) {
        throw error.response?.data?.message || error.message || 'حدث خطأ أثناء تغيير حالة المشرف';
    }
};

// خدمات المدربين
export const fetchInstructors = async (params = {}) => {
    try {
        const response = await axiosInstance.get('/api/admin/users', { 
            params: { 
                ...params,
                role_id: 3 // عرض المدربين فقط في صفحة المدربين
            } 
        });
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message || 'حدث خطأ أثناء جلب المدربين';
    }
};

export const createInstructor = async (instructorData) => {
    try {
        // الآن نستخدم البيانات من نموذج الإضافة مباشرة
        // لأن المستخدم يختار الدور من القائمة المنسدلة
        const response = await axiosInstance.post('/api/admin/users', instructorData);
        return response.data;
    } catch (error) {
        if (error.response?.data?.errors) {
            const errorMessages = Object.values(error.response.data.errors).flat();
            throw errorMessages.join('\n');
        }
        
        // التحقق من خطأ تكرار رقم الجوال
        if (error.response?.data?.message?.includes('Duplicate entry') && 
            error.response?.data?.message?.includes('phone_unique')) {
            throw 'رقم الجوال مستخدم بالفعل. الرجاء إدخال رقم جوال آخر.';
        }
        
        throw error.response?.data?.message || error.message || 'حدث خطأ أثناء إضافة المدرب';
    }
};

export const updateInstructor = async (id, instructorData) => {
    try {
        const response = await axiosInstance.put(`/api/admin/users/${id}`, instructorData);
        return response.data;
    } catch (error) {
        if (error.response?.data?.errors) {
            const errorMessages = Object.values(error.response.data.errors).flat();
            throw errorMessages.join('\n');
        }
        throw error.response?.data?.message || error.message || 'حدث خطأ أثناء تحديث بيانات المدرب';
    }
};

export const deleteInstructor = async (id) => {
    try {
        const response = await axiosInstance.delete(`/api/admin/users/${id}`);
        return response.data;
    } catch (error) {
        throw error.response?.data?.message || error.message || 'حدث خطأ أثناء حذف المدرب';
    }
};

export const changeInstructorPassword = async (id, passwordData) => {
    try {
        const response = await axiosInstance.post(`/api/admin/users/${id}/change-password`, passwordData);
        return response.data;
    } catch (error) {
        if (error.response?.data?.errors) {
            const errorMessages = Object.values(error.response.data.errors).flat();
            throw errorMessages.join('\n');
        }
        throw error.response?.data?.message || error.message || 'حدث خطأ أثناء تغيير كلمة المرور';
    }
};

export const changeInstructorStatus = async (id, isBanned) => {
    try {
        // استخدام المسار الصحيح PUT /api/admin/users/{id}
        const response = await axiosInstance.put(`/api/admin/users/${id}`, { 
            status: isBanned ? 'محظور' : 'نشط' 
        });
        return response.data;
    } catch (error) {
        throw error.response?.data?.message || error.message || 'حدث خطأ أثناء تغيير حالة المدرب';
    }
};

// خدمات المتدربين
export const fetchTrainees = async (params = {}) => {
    try {
        const response = await axiosInstance.get('/api/admin/users', { 
            params: { 
                ...params,
                exclude_role_ids: [1, 2, 3]
            } 
        });
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message || 'حدث خطأ أثناء جلب المتدربين';
    }
};

export const fetchTraineeStats = async (params = {}) => {
    try {
        const response = await axiosInstance.get('/api/admin/users/stats', {
            params: {
                ...params,
                exclude_role_ids: [1, 2, 3]
            }
        });
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message || 'حدث خطأ أثناء جلب الإحصائيات';
    }
};

export const createTrainee = async (traineeData) => {
    try {
        // الآن نستخدم الدور من البيانات المرسلة مباشرة، بدون تعديل
        // لأن المستخدم يختار الدور من القائمة المنسدلة
        const response = await axiosInstance.post('/api/admin/users', traineeData);
        return response.data;
    } catch (error) {
        if (error.response?.data?.errors) {
            const errorMessages = Object.values(error.response.data.errors).flat();
            throw errorMessages.join('\n');
        }
        throw error.response?.data?.message || error.message || 'حدث خطأ أثناء إضافة المتدرب';
    }
};

export const updateTrainee = async (id, traineeData) => {
    try {
        const response = await axiosInstance.put(`/api/admin/users/${id}`, traineeData);
        return response.data;
    } catch (error) {
        if (error.response?.data?.errors) {
            const errorMessages = Object.values(error.response.data.errors).flat();
            throw errorMessages.join('\n');
        }
        throw error.response?.data?.message || error.message || 'حدث خطأ أثناء تحديث بيانات المتدرب';
    }
};

export const deleteTrainee = async (id) => {
    try {
        const response = await axiosInstance.delete(`/api/admin/users/${id}`);
        return response.data;
    } catch (error) {
        throw error.response?.data?.message || error.message || 'حدث خطأ أثناء حذف المتدرب';
    }
};

export const changeTraineeStatus = async (id, isBanned) => {
    try {
        // استخدام المسار الصحيح PUT /api/admin/users/{id}
        const response = await axiosInstance.put(`/api/admin/users/${id}`, { 
            status: isBanned ? 'محظور' : 'نشط' 
        });
        return response.data;
    } catch (error) {
        throw error.response?.data?.message || error.message || 'حدث خطأ أثناء تغيير حالة المتدرب';
    }
};

export const changeTraineePassword = async (id, passwordData) => {
    try {
        const response = await axiosInstance.post(`/api/admin/users/${id}/change-password`, passwordData);
        return response.data;
    } catch (error) {
        if (error.response?.data?.errors) {
            const errorMessages = Object.values(error.response.data.errors).flat();
            throw errorMessages.join('\n');
        }
        throw error.response?.data?.message || error.message || 'حدث خطأ أثناء تغيير كلمة المرور';
    }
};

// جلب الأدوار المتاحة من الباك إند
export const fetchRoles = async () => {
    try {
        // المسار الجديد لجلب الأدوار - متاح لأي مستخدم عنده صلاحية الدخول للوحة التحكم
        const response = await axiosInstance.get('/api/dashboard/roles/permissions');
        
        // تنسيق البيانات لتناسب الشكل المطلوب
        if (response.data && Array.isArray(response.data)) {
            return { data: response.data };
        } else if (response.data && response.data.roles && Array.isArray(response.data.roles)) {
            return { data: response.data.roles };
        }
        
        throw new Error('بيانات غير صالحة');
    } catch (error) {
        throw error.response?.data || error.message || 'حدث خطأ أثناء جلب الأدوار';
    }
};

export const usersService = {
    fetchAdmins,
    createAdmin,
    updateAdmin,
    deleteAdmin,
    changeAdminPassword,
    changeAdminStatus,
    fetchInstructors,
    createInstructor,
    updateInstructor,
    deleteInstructor,
    changeInstructorPassword,
    changeInstructorStatus,
    fetchTrainees,
    createTrainee,
    updateTrainee,
    deleteTrainee,
    changeTraineeStatus,
    changeTraineePassword,
    fetchTraineeStats,
    fetchRoles
};

export default usersService;
